import { Component, OnDestroy, OnInit, ViewChild, ElementRef, HostListener } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { AppInsightsService } from 'src/app/services/app-insights.service';
import { DocumentService } from 'src/app/services/document.service';
import { PdfDocumentService } from 'src/app/services/pdf-document.service';

@Component({
  selector: 'tx-answers-changed-dialog',
  templateUrl: './answers-changed-dialog.component.html',
  styleUrls: ['./answers-changed-dialog.component.scss'],
})
export class AnswersChangedDialogComponent implements OnInit, OnDestroy {
  public showSecondaryConfirmation: boolean = false;
  public documentDisconnectedFromTXdocsAnswerPool: boolean = false;
  @ViewChild('modalContainer', { static: true }) modalContainer!: ElementRef;

  constructor(
    public activeModal: NgbActiveModal,
    private logger: AppInsightsService,
    private documentService: DocumentService,
    private pdfDocumentService: PdfDocumentService
  ) {}

  ngOnInit(): void {
    document.addEventListener('keydown', this.handleKeyDown.bind(this));
    //ensure init as false
    this.documentService.setDocumentDisconnected(false);
    this.pdfDocumentService.setDocumentDisconnected(false);
    this.logger.logEvent('Newer case answers available dialog popped up');
  }

  ngOnDestroy() {
    document.removeEventListener('keydown', this.handleKeyDown.bind(this));
  }

  ngAfterViewInit() {
    this.modalContainer.nativeElement.focus();
  }

  handleKeyDown(event: KeyboardEvent): void {
    if (event.key === 'Enter') {
      this.handleYes();
    }
  }

  public handleYes() {
    this.logger.logTrace('CaseAnswersDialogAction', { userAction: 'User Selected Yes' });
    //pass variable to documentService for edit-document component
    this.documentService.setDocumentDisconnected(this.documentDisconnectedFromTXdocsAnswerPool);
    this.pdfDocumentService.setDocumentDisconnected(this.documentDisconnectedFromTXdocsAnswerPool);
    this.activeModal.close(true);
  }

  public handleNoConfirmation() {
    this.showSecondaryConfirmation = false;
    this.logger.logTrace('CaseAnswersDialogAction', { userAction: 'User Selected No - Answer Pool Disconnected' });
    this.documentDisconnectedFromTXdocsAnswerPool = true;
    //pass variable to documentService for edit-document component & tge pdf component
    this.documentService.setDocumentDisconnected(this.documentDisconnectedFromTXdocsAnswerPool);
    this.pdfDocumentService.setDocumentDisconnected(this.documentDisconnectedFromTXdocsAnswerPool);
    this.activeModal.close(false);
  }
}
